<template>
    <span>
        <WtcName :competitor-name="normalizedName" :href="hrefToAthleteBios" :tag="nameTag" target="_blank"></WtcName>
    </span>
</template>

<script setup lang="ts">
import { WtcName } from "@swisstiming/webtec-kit";
import { isEmpty } from "lodash-es";
import { computed } from "vue";

import { IAthlete } from "../../interfaces/wdl-archive.interfaces";

const props = defineProps<{
    competitor?: IAthlete;
}>();

const normalizedName = computed(() => {
    if (props.competitor.FirstName) {
        return {
            Name: props.competitor.LastName,
            FirstName: props.competitor.FirstName
        };
    } else {
        const name = props.competitor.LastName?.trim();

        // Check if there is only one name, which frees us from parsing further.
        if (!name?.includes(" ")) {
            return {
                Name: name
            };
        }

        // Split names into its parts
        const parts = name.split(/\s+/);

        // Declare common suffixes of names.
        const suffixes = new Set(["jr.", "sr.", "ii", "iii", "iv", "v"]);

        let suffix = "";

        if (suffixes.has(parts[parts.length - 1].toLowerCase())) {
            suffix = parts.pop()!; // Remove suffix from name.
        }
        const lastName = parts.pop()!; // last word is the last name.
        const firstName = parts.join(" ");

        // Reconstruct the name.
        if (suffix) {
            return {
                Name: props.competitor.Name,
                FirstName: `${firstName} ${suffix}`
            };
        } else {
            return {
                Name: lastName,
                FirstName: firstName
            };
        }
    }
});

const nameTag = computed(() => (props.competitor?.AthleteId !== undefined ? "a" : "span"));
const hrefToAthleteBios = computed(() => `${document.referrer}athlete/${props.competitor.AthleteId}`);
</script>

<style scoped lang="scss"></style>
